<div class="account-team-selector" *ngIf="isTranslationLoaded">
  <div class="selectors-container">

    <!-- Account Selector -->
    <div class="selector-group" *ngIf="accountOptions.length > 1">
      <qai-label class="selector-label" kind="secondary" size="small" weight="regular">
        {{ 'reportingV2.ACCOUNT' | transloco }}
      </qai-label>

      <!-- Single Customer - Multiple Accounts -->
      <qai-floating-select *ngIf="multipleCustomers.length === 0 && accountOptions.length > 1"
        [options]="accountOptions" [placeholder]="isLoadingAccounts 
          ? ('reportingV2.LOADING_ACCOUNTS' | transloco) 
          : ('reportingV2.SELECT_AN_ACCOUNT' | transloco)" placement="below-start" [offset]="4" shape="round"
        [value]="selectedAccount?.value" [disabled]="isLoadingAccounts" (valueChange)="onAccountChange($event)">
      </qai-floating-select>

      <!-- Multiple Customers -->
      <qai-account-selector *ngIf="multipleCustomers.length > 1" [accountsByCustomer]="multipleCustomers"
        placeholder="Please select an account" parentAccountLabel="Parent Account" accountLabel="Account" [sortAlphabetically]="true"
        placement="below-start" [selectedAccountId]="selectedAccount?.value || null"
        (valueChange)="onAccountChange($event)">
      </qai-account-selector>
    </div>

    <!-- Team Selector -->
    <div class="selector-group" *ngIf="teamOptions.length > 1">
      <qai-label class="selector-label" kind="secondary" size="small" weight="regular">
        {{ 'reportingV2.TEAMS' | transloco }}
      </qai-label>

      <qai-multiselect [options]="teamOptions" [placeholder]="isLoadingTeams 
          ? ('reportingV2.LOADING_TEAMS' | transloco) 
          : ('reportingV2.SEARCH_TEAMS' | transloco)" placement="below-start" [offset]="4" startIcon="search"
        [value]="selectedTeams" [disabled]="isLoadingTeams" (valueChange)="onTeamChange($event)"
        [persistSearch]="true" [clearButton]="clearOption" [selectionDisplayMode]="'single-row-truncated'"
        [visibleOptionsSelectionMode]="visibleOptionsMode">
      </qai-multiselect>
    </div>

  </div>
</div>